import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Helmet } from "react-helmet";
// import AboutTowers from "../components/aboutTowers";
import Footer from "../components/footer";
import Header from "../components/header";
import Infrastructure from "../components/infrastructure";
import Kpi from "../components/kpi";
import Overview from "../components/overview";
import Spinner from "../components/spinner";
import TableOfContents from "../components/table-of-contents";
import TopNavabr from "../components/topNavabr";
import WhereWork from "../components/whereWork";
import { BASE_URL } from "../data/baseURL";
import { whereWeWorksSubmenu } from "../data/where-we-work-submenu";
import { useScrollTop } from "../hook/useScrollTop";

const WhereWeWork = () => {
  const { data, isLoading } = useQuery(["whereWeWork"], async () => {
    const response = await window.fetch(`${BASE_URL}/where-we-work`);
    return await response.json();
  });
  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }
  const {
    where_work_banner,
    where_work_kps,
    where_work_overview,
    where_work_video,
  } = data?.where;
  return (
    <>
      <Helmet>
        <title>AFRO || Where We Work</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={
          Boolean(where_work_banner?.default) ? "video" : "image"
        }
        videoURL={where_work_banner?.video}
        imageURL={where_work_banner?.image}
      >
        <div className="pt-7 pb-5 text-center">
          <h1
            className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size"
            dangerouslySetInnerHTML={{ __html: where_work_banner?.title }}
          />
        </div>
      </Header>
      <section className="d-none d-lg-block">
        <ul className="row text-center bg-bright-gray fs-14 list-style-none m-0 p-0">
          {whereWeWorksSubmenu.map((menu, index) => (
            <li
              key={menu.index}
              className="col-4 fs-16  border-gray submenu-link"
            >
              <a
                href={menu.link}
                className="text-decoration-none text-orange-ryb gilroy-bold py-4 d-block"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={whereWeWorksSubmenu} />
      <Infrastructure />
      <WhereWork where_work_video={where_work_video} />
      <Overview where_work_overview={where_work_overview} />
      <Kpi where_work_kps={where_work_kps} />
      {/* <AboutTowers /> */}
      <Footer />
    </>
  );
};

export default WhereWeWork;
